// This is mockup code for the Telemery service.
interface ITelemetry {
  stopTrackPage(title: string, url: string, pageTrackingDetails?: any): void;
  startTrackPage(): void;
  stopTrackEvent(event: string, properties?: Record<string, any>): void;
  startTrackEvent(event: string): void;
  trackEvent(data: Record<string, any>, dimensions?: Record<string, any>): void;
}

class MockTelemetry implements ITelemetry {
  stopTrackPage(title: string, url: string, pageTrackingDetails?: any): void {}

  startTrackPage(): void {}

  stopTrackEvent(event: string, properties?: Record<string, any>): void {}

  startTrackEvent(event: string): void {}

  trackEvent(data: Record<string, any>, dimensions?: Record<string, any>): void {}
}

const telemetry: ITelemetry = new MockTelemetry();
export { telemetry };
